<script>
  import SmallTitle from '../common/SmallTitle.svelte';
  import RocketHand from './RocketHand.svelte';

  export let values = [];
  export let lang = undefined;
  export let mode = undefined;

  const i18n = {
    underEightYears: {
      en: 'Under 8 years',
      cs: 'Do 8 let',
    },
    underTenYears: {
      en: 'Under 10 years',
      cs: 'Do 10 let',
    },
    underTwelveYears: {
      en: 'Under 12 years',
      cs: 'Do 12 let',
    },
    underFifteenYears: {
      en: 'Under 15 years',
      cs: 'Do 15 let',
    },
    fifteenYearsAndAbove: {
      en: '15 years and above',
      cs: '15 let a více',
    },
  };

  const categoryUnder8Values = values.filter(value => value.category === 'u8');
  const categoryUnder10Values = values.filter(value => value.category === 'u10');
  const categoryUnder12Values = values.filter(value => value.category === 'u12');
  const categoryUnder15Values = values.filter(value => value.category === 'u15');
  const category15PlusValues = values.filter(value => value.category === '15+');
</script>

<div class='rocket-hand-box'>
  <div class='rocket-hand-box-category'>
    <div class='rocket-hand-box-category-small-title'>
      <SmallTitle value='U8' append={i18n.underEightYears[lang]}/>
    </div>

    <div class='rocket-hand-box-category-rocket-hand'>
      <RocketHand value={categoryUnder8Values} bind:lang bind:mode/>
    </div>
  </div>

  <div class='rocket-hand-box-category'>
    <div class='rocket-hand-box-category-small-title'>
      <SmallTitle value='U10' append={i18n.underTenYears[lang]}/>
    </div>

    <div class='rocket-hand-box-category-rocket-hand'>
      <RocketHand value={categoryUnder10Values} bind:lang bind:mode/>
    </div>
  </div>

  <div class='rocket-hand-box-category'>
    <div class='rocket-hand-box-category-small-title'>
      <SmallTitle value='U12' append={i18n.underTwelveYears[lang]}/>
    </div>

    <div class='rocket-hand-box-category-rocket-hand'>
      <RocketHand value={categoryUnder12Values} bind:lang bind:mode/>
    </div>
  </div>

  <div class='rocket-hand-box-category'>
    <div class='rocket-hand-box-category-small-title'>
      <SmallTitle value='U15' append={i18n.underFifteenYears[lang]}/>
    </div>

    <div class='rocket-hand-box-category-rocket-hand'>
      <RocketHand value={categoryUnder15Values} bind:lang bind:mode/>
    </div>
  </div>

  <div class='rocket-hand-box-category'>
    <div class='rocket-hand-box-category-small-title'>
      <SmallTitle value='15+' append={i18n.fifteenYearsAndAbove[lang]}/>
    </div>

    <div class='rocket-hand-box-category-rocket-hand'>
      <RocketHand value={category15PlusValues} bind:lang bind:mode/>
    </div>
  </div>
</div>

<style>
  .rocket-hand-box {
    display: flex;
    flex-wrap: wrap;
    gap: 40px;
  }

  .rocket-hand-box-category {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    gap: 20px;

    width: calc((100% - 80px) / 3);
  }

  .rocket-hand-box-category-rocket-hand {
    height: 300px;
  }

  @media only screen and (max-width: 1450px) {
    .rocket-hand-box-category {
      width: calc((100% - 40px) / 2);
    }
  }

  @media only screen and (max-width: 1000px) {
    .rocket-hand-box-category {
      width: 100%;
    }
  }
</style>
